window.samplesDataObj = {
  55: ['£'],
  65: ['€']
}

function* uniqueIDGenerator(){
    let count = 0;
    while(true){
      yield count++;
    }
  }
  
  function NotificationController(freeSamples, topBar) {
    let notificationTemplate = document.querySelector('.top-bar__notification-template').content;
    let notifications = [];
    let uniqueID = uniqueIDGenerator();
    
    function showSamplingNotification(textContent = '') {
      if (!freeSamples) {
        return
      }
      if (!topBar.querySelector('.text-shipping.samples')) {
        let htmlEle = generateNotificationElement(textContent, 'samples');
        topBar.append(htmlEle);
        topBar.classList.remove('hidden');
        samplesImg = htmlEle.querySelector('[class*=img-]')
      } else {
        if (textContent != '') {
          topBar.style.display = 'block';
          notifications.filter((item)=>{return item.type == 'samples'}).forEach(({ele, key})=>{
            notifications.find((item)=>item.key == key).active = true;
            ele.querySelector('.first-difference-span').innerHTML = textContent;
            ele.style.display = 'flex';
          })
        }
      }
    }

    function disableSamplingNotification() {
        notifications.filter((item)=>{return item.type == 'samples'}).forEach(({ele, key})=>{
            notifications.find((item)=>item.key == key).active = false;
            ele.style.display = '';
            ele.classList.add("disabled");
        })
    }
  
    function hideSamplingNotification() {
      notifications.filter((item)=>{return item.type == 'samples'}).forEach(({ele, key})=>{
        notifications.find((item)=>item.key == key).active = false;
        ele.style.display = 'none';
      })
    }
  
    function showSamplingSlider() {
        if (freeSamples) {
            freeSamples.style.display = 'block';
            freeSamples.classList.remove("disabled");
        }
    }
    function hideSamplingSlider() {
        if (freeSamples) {
            freeSamples.style.display = 'none';
        }
    }
    function disableSamplingSlider() {
        if (freeSamples) {
            freeSamples.style.display = '';
            freeSamples.classList.add("disabled");
        }
    }
  
    function showShippingNotification(textContent = '') {
      if (!topBar.querySelector('.text-shipping.shipping')) {
        let htmlEle = generateNotificationElement(textContent,'shipping');
        topBar.append(htmlEle);
        topBar.classList.remove('hidden');
        shippingImg = htmlEle.querySelector('[class*=img-]')
      } else {
        if (textContent != '') {
          topBar.style.display = 'block';
          topBar.classList.remove('hidden');
          notifications.filter((item)=>{return item.type == 'shipping'}).forEach(({ele, key}, index)=>{
            notifications.find((item)=>item.key == key).active = true;
            ele.querySelector('.first-difference-span').innerHTML = textContent;
            ele.style.display = 'flex';
          })
        }
      }
    }
  
    function hideShippingNotification() {
      notifications.filter((item)=>{return item.type == 'shipping'}).forEach(({ele, key})=>{
        notifications.find((item)=>item.key == key).active = false;
        ele.style.display = 'none';
      })
    }
  
    function generateNotificationElement(textContent = '', notificationType) {
      let tempEle = notificationTemplate.cloneNode(true).firstElementChild;
      tempEle.classList.add(notificationType?.toLowerCase());
      tempEle.querySelector('.text-shipping').classList.add(notificationType?.toLowerCase());
      let uid = uniqueID.next().value;
      tempEle.dataset.key = uid;
      if (uid = 0) {
        tempEle.classList.add('first');
      }
  
      tempEle.querySelectorAll('[class^=img-]').forEach((item) => {
        let itemClassNameIncludesType = item.className?.split(' ').some((_class)=>{ return _class.includes(notificationType) });
        if (itemClassNameIncludesType) {
          item.style.display = 'inline-flex';
        } else {
          item.style.display = 'none';
        }
      });
      tempEle.querySelector('.first-difference-span').innerHTML = textContent;
      notifications.push({ele:tempEle, type:notificationType, active: textContent != '', key: uid});
      return tempEle;
    }
  
    return {
      showSamplingNotification,
      hideSamplingNotification,
      disableSamplingNotification,
      showSamplingSlider,
      hideSamplingSlider,
      disableSamplingSlider,
      showShippingNotification,
      hideShippingNotification,
      generateNotificationElement
    }
  }
  window.notificationController = undefined;
  
  class CartNotification extends HTMLElement {
    constructor() {
      super();
  
      this.wrapper = this.querySelector('.cart-notification-wrapper');
      this.notification = document.getElementById('cart-notification');
      this.header = document.querySelector('sticky-header');
      this.body = document.querySelector('body');
      this.topHeader = document.getElementById('shopify-section-header')
      this.onBodyClick = this.handleBodyClick.bind(this);
  
      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }
  
    open() {
      this.notification.classList.add('animate', 'active');
      this.wrapper.classList.add('animate', 'active');
      this.topHeader.classList.add('menu-open');
      this.body.classList.add('menu-open');
      this.notification.addEventListener('transitionend', () => {
        this.notification.focus();
        trapFocus(this.notification);
      }, { once: true });
  /*
      if(sessionStorage.getItem('pumpedProductsClosed') === 'true') {
        document.querySelector('.bottom-wrapper').style.display = "none";
      }*/
      let pumpedProductsClosed = sessionStorage.getItem('pumpedProductsClosed');
      if(pumpedProductsClosed) {
          pumpedProductsClosed = JSON.parse(pumpedProductsClosed);
          for(let i = 0; i < pumpedProductsClosed.length; i++) {
              document.querySelector(`.cart-item-row input[value="${pumpedProductsClosed[i]}"]`).parentElement.querySelector('.bottom-wrapper').style.display = "none";
          }
      }
      document.body.addEventListener('mouseup', this.onBodyClick);
    
    }
  
    close() {
      this.notification.classList.remove('active');
      this.wrapper.classList.remove('active');
      this.topHeader.classList.remove('menu-open');
      this.body.classList.remove('menu-open');
      document.body.removeEventListener('mouseup', this.onBodyClick);
  
      removeTrapFocus(this.activeElement);
    }
  
    samplesAlreadyAdded () {
      let itemsArr = document.querySelectorAll('.cart-notification-wrapper .cart-item-row');
      let freeSamplesArr = document.querySelectorAll('.free-samples__item .add-sample-variant-id');
  
      let freeSamplesIdsArr = Array.from(freeSamplesArr).map(item => item.value);
      let count = [];
      itemsArr.forEach(item => {
        let itemId = item.querySelector('.item-variant-id').value;
        if(freeSamplesIdsArr.includes(itemId)) {
          count.push(itemId);
        }
      })
  
      return count?.length >= 2;
    }
  
    removeQuantitiesForSamples() {
  
      // check if free sample is already added
      let itemsArr = document.querySelectorAll('.cart-notification-wrapper .cart-item-row');
      let freeSamplesArr = document.querySelectorAll('.free-samples__item .add-sample-variant-id');
  
      let freeSamplesIdsArr = Array.from(freeSamplesArr).map(item => item.value);
      let count = [];
      itemsArr.forEach(item => {
        let itemId = item.querySelector('.item-variant-id').value;
        if(freeSamplesIdsArr.includes(itemId)) {
          count.push(itemId);
          document.querySelector(`.free-samples__item input[value="${itemId}"]`).parentNode.style.display = 'none';
          item.querySelector('quantity-input').remove();
          document.querySelector('.swiper.free-samples')?.swiper?.update(true);
        }
      })
      freeSamplesArr.forEach(item => {
        if (!count.includes(item.value)) {
          item.parentNode.style.display = 'block';
        }
      })
      return count;
    }
  
    renderContents(parsedState) {
        this.getSectionsToRender().forEach((section => {
          document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            if(section && section.section === 'cart-icon-bubble') {
              let iconBubble =  this.getSectionInnerHTML(parsedState.sections[section.section], '.shopify-section .cart-count-bubble');
              let mobileIconBubble = document.querySelector('.header__icons.hide-for-xlarge .cart-count-bubble');
              if(iconBubble && mobileIconBubble) mobileIconBubble.innerHTML = iconBubble;
            }
        }));
  
        const initializeSwiper = () => {
          let selector = document.querySelector('.swiper.free-samples');
          if(selector && !selector.classList.contains('swiper-initialized')) {
            new Swiper('.swiper.free-samples', {
              spaceBetween: 10,
              slidesPerView: 1.4,
              clickable: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }
            });
          } 
        }
  
        let totalCost = document.querySelector('.cart-item-row .total-price').value;
        let currencySymbol = document.querySelector('.currency-symbol').value;
        let countryCode = document.querySelector('.country-iso-code').value;
        let freeSamples = document.querySelector('.free-samples');
        let bottomShipping = document.querySelector('.free-shipping');
        let topBar = document.querySelector('.top-bar-container');
  
        let totalCostFormatted = parseInt(totalCost.replace(/[^0-9]/g, '').split('.')[0]);
  
        document.getElementById('subtotal').innerHTML = totalCost;
        document.querySelector('.btn-money').innerHTML = totalCost;
  
        const qualifiedFreeShippingText = document.querySelector('.qualified-free-shipping').value;
        const bottomShippingTaxesText = document.querySelector('.bottom-shipping-taxes').value;	
        const chooseFreeSamplesText = document.querySelector('.choose-free-samples') && document.querySelector('.choose-free-samples').value || "";
        const announcementSpendText = document.querySelector('.announcement-spend').value;
        const announcementFreeShippingText = document.querySelector('.announcement-free-shipping').value;
        const announcementFreeSampleText = document.querySelector('.announcement-free-sample').value;
  
        // Gift Card Total
        let giftCardTotal = 0;
        const giftCardsElms = document.querySelectorAll('.item-variant-isGiftCard');
        const giftCards = [...giftCardsElms];
        giftCards.forEach((giftCard) => {
          giftCardTotal += Number(giftCard.previousElementSibling.value);
        });

        let refillPouchTotalPrice = Array.from(document.querySelectorAll('.item-variant-isRefillPouch'))
        .map((item)=>{return +item.parentElement.querySelector('.item-variantLine-price').value})
        .reduce((a,b)=>{
          return a + b
        }, 0);


        let samplesAdded = this.samplesAlreadyAdded();
        const totalMinusGiftCards = totalCostFormatted - giftCardTotal;

        let showSampling = false;
        let showSamplingSlider = false;
        let showShipping = false;
        let notificationPositions = [];

        let shippingDataObj = window.shippingDataObj && Object.entries(window.shippingDataObj).length ? window.shippingDataObj : {
          40: ['gb'],
          50: ['ie', 'at', 'nl', 'de', 'fr', 'be', 'es', 'it', 'pl', 'lu', 'sk', 'cz', 'dk', 'us'],
          80: ['bg', 'hr', 'ee', 'fi', 'gr', 'hu', 'lv', 'lt', 'no', 'pt', 'ro', 'rs', 'si', 'se']
        };
        let shippingDataEntries = Object.entries(shippingDataObj);
        let shippingThresholdIndex = shippingDataEntries.findIndex((code)=>{ return code[1].includes(countryCode.toLowerCase()) });
        let shippingAmountLeft = -1;

        if (shippingThresholdIndex > -1) {
          let shippingthresholdValue = +shippingDataEntries[shippingThresholdIndex][0] * 100;
          notificationPositions.push({type:'shipping', value:shippingthresholdValue})
          shippingAmountLeft = (shippingthresholdValue - totalMinusGiftCards);
          if (shippingAmountLeft > 0) {
            showShipping = true;
          }
        }

        let samplesDataObj = {
          55: ['£'],
          65: ['€']
        }

        let samplesDataEntries = Object.entries(samplesDataObj);
        let samplesThresholdIndex = samplesDataEntries.findIndex((code)=>{ return code[1].includes(currencySymbol.toLowerCase()) });
        let samplesAmountLeft = -1;

        if (samplesThresholdIndex > -1) {
          let samplesthresholdValue = +samplesDataEntries[samplesThresholdIndex][0] * 100;
          notificationPositions.push({type:'samples', value:samplesthresholdValue})
          samplesAmountLeft = (samplesthresholdValue - (totalMinusGiftCards - refillPouchTotalPrice));
          showSampling = true;
          if (samplesAmountLeft <= 0 && !samplesAdded) {
            showSamplingSlider = true;
          }
          if (samplesAdded) {
            showSampling = false;
          }
        }

        notificationPositions = notificationPositions.sort((a,b)=>Number(a.value)>Number(b.value)?1:-1);
        notificationController = notificationController || NotificationController(freeSamples, topBar);

        if (!showShipping && !showSampling) {
          //hide all
          notificationController.hideShippingNotification();
          notificationController.hideSamplingNotification();
          notificationController.hideSamplingSlider();
          topBar.style.display = 'none';
        } else {
          notificationPositions.forEach((item)=>{
            if (item.type == 'samples') {
              notificationController.showSamplingNotification();
              if (showSampling) {
                if (showSamplingSlider) {
                  notificationController.showSamplingSlider();
                  // show sample slider
                  notificationController.showSamplingNotification(`${chooseFreeSamplesText}`)
  
  
                  initializeSwiper();
  
                  let count = this.removeQuantitiesForSamples();
                  if (count.length >= 2) {
                    if (freeSamples) {
                      // freeSamples.style.display = 'none';
                    }
                    // topBar.style.display = 'none';
                  } else {
                    if (freeSamples) {
                      // freeSamples.style.display = 'block';
                    }
                    topBar.querySelectorAll('.top-bar').forEach((item) => {
                      if (item.classList?.contains('samples')) {
                        item.style.order = 2;
                      } else {
                        item.style.order = 1;
                      }
                    });
                    topBar.style.display = 'flex';
                    topBar.querySelector('.top-bar.samples')?.classList.remove("disabled");
                    document.querySelector('.swiper.free-samples')?.swiper?.update(true);
                  }
                } else {
                  if (samplesAmountLeft > 0) {
                    initializeSwiper();
                    notificationController.disableSamplingNotification()
                  } else {
                    notificationController.hideSamplingSlider()
                  }
                  let formatMoney = (samplesAmountLeft.toFixed(2) * .01).toFixed(2);
                  notificationController.showSamplingNotification(`${announcementSpendText} ${currencySymbol}${formatMoney} ${announcementFreeSampleText}`);
                  topBar.querySelector('.top-bar.samples')?.classList.add("disabled");
                }
              } else {
                notificationController.hideSamplingNotification()
              }
            }
            if (item.type == 'shipping') {
              notificationController.showShippingNotification();
              if (showShipping) {
                let formatMoney = (shippingAmountLeft.toFixed(2) * .01).toFixed(2);
                let notificationText = `${announcementSpendText} ${currencySymbol}${formatMoney} ${announcementFreeShippingText}`
                notificationController.showShippingNotification(notificationText);
              } else {
                notificationController.hideShippingNotification()
              }
            }
          });
          if (!showSamplingSlider) {
            if (samplesAmountLeft > 0) {
              notificationController.disableSamplingSlider();
            } else {
              notificationController.hideSamplingSlider();
            }
          }
        }
    
        /* Subtotal */
        if(shippingAmountLeft <= 0 && shippingThresholdIndex != -1) {
          bottomShipping.innerHTML = `${qualifiedFreeShippingText}`;
        } else {
          bottomShipping.innerHTML = `${bottomShippingTaxesText}`;
        }
  
        const pumpedProductsIds = localStorage.getItem('pumpedProducts');
        if(pumpedProductsIds) {
          const pumpedProducts = JSON.parse(pumpedProductsIds);
          pumpedProducts?.map(productId => {
              let pumpElement = document.querySelector('input[value="' + productId + '"].item-variant-id')?.parentNode?.querySelector('.bottom-wrapper');
              pumpElement?.remove();
          });
        }
  
        console.log(this.header)
        if (this.header) this.header?.reveal();
        this.open();
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          // selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
          selector: '.cart-notification-wrapper',
        },
        // {
        //   id: 'cart-notification-button'
        // },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
  
    handleBodyClick(evt) {
      const target = evt.target;
      if (target?.classList?.contains('cart-notification-wrapper')) {
        const disclosure = target.closest('details-disclosure, header-menu');
        this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
        document.body.classList.toggle('cart-notification-open');
        this.close();
      }
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-notification', CartNotification);
